/**
 * PANEL_LEVEL - Panel seviye enum'u
 */
export const PANEL_LEVEL = {
  PRIMARY: 'PRIMARY',     // Ana panel tipleri (Mesken, İşyeri, Asansör)
  GT_CHILD: 'GT_CHILD',   // GT alt panelleri (THP, SP, OP, KP, YPP)
};

/**
 * PANEL_TYPES - 9 panel tipi tanımı
 * Her tip defaultOutputs ve allowedChildPanels dizisine sahiptir
 */
export const PANEL_TYPES = {
  GT: {
    id: 'GT',
    code: 'GT',
    label: 'Müşterek (GT)',
    level: PANEL_LEVEL.PRIMARY,
    defaultOutputs: [
      'PRZ_NORMAL',
      'AYD_MERDIVEN',
      'AYD_ASANSOR',
      'MKN_HIDROFOR',
      'MTR_CAMASIR',
      'MTR_BULASIK',
      'MTR_FIRIN',
      'MTR_MOTOR',
      'MTR_KOMBI',
      'MTR_KLIMA',
      'MTR_FAN',
      'MTR_HIDROFOR',
      'ZAK_ZIL',
      'ZAK_INTERKOM',
    ],
    allowedChildPanels: ['THP', 'SP', 'OP', 'KDP'],
  },
  MESKEN: {
    id: 'MESKEN',
    code: 'MESKEN',
    label: 'Mesken',
    level: PANEL_LEVEL.PRIMARY,
    defaultOutputs: [
      'PRZ_NORMAL',
      'AYD_NORMAL',
      'MKN_CAMASIR',
      'MKN_KURUTMA',
      'MKN_BULASIK',
      'MKN_FIRIN',
      'MKN_KOMBI',
      'MKN_KLIMA',
      'MTR_CAMASIR',
      'MTR_BULASIK',
      'MTR_FIRIN',
      'MTR_MOTOR',
      'MTR_KOMBI',
      'MTR_KLIMA',
      'MTR_FAN',
      'MTR_HIDROFOR',
      'ZAK_ZIL',
      'ZAK_INTERKOM',
    ],
    allowedChildPanels: ['MESKEN'],
  },
  ISYERI: {
    id: 'ISYERI',
    code: 'ISYERI',
    label: 'İşyeri',
    level: PANEL_LEVEL.PRIMARY,
    defaultOutputs: [
      'PRZ_NORMAL',
      'AYD_NORMAL',
      'MKN_KLIMA',
      'MKN_FAN',
      'MTR_CAMASIR',
      'MTR_BULASIK',
      'MTR_FIRIN',
      'MTR_MOTOR',
      'MTR_KOMBI',
      'MTR_KLIMA',
      'MTR_FAN',
      'MTR_HIDROFOR',
      'ZAK_ZIL',
      'ZAK_INTERKOM',
    ],
    allowedChildPanels: ['ISYERI'],
  },
  ASANSOR: {
    id: 'ASANSOR',
    code: 'ASANSOR',
    label: 'Asansör',
    level: PANEL_LEVEL.PRIMARY,
    defaultOutputs: [
      'PRZ_NORMAL',
      'AYD_ASANSOR',
      'MKN_MOTOR',
      'MTR_CAMASIR',
      'MTR_BULASIK',
      'MTR_FIRIN',
      'MTR_MOTOR',
      'MTR_KOMBI',
      'MTR_KLIMA',
      'MTR_FAN',
      'MTR_HIDROFOR',
    ],
    allowedChildPanels: [],
  },

  // --- GT Alt Panelleri ---
  THP: {
    id: 'THP',
    code: 'THP',
    label: 'Teknik Hol Panosu',
    level: PANEL_LEVEL.GT_CHILD,
    defaultOutputs: [
      'PRZ_NORMAL',
      'AYD_MERDIVEN',
      'MKN_HIDROFOR',
      'MTR_CAMASIR',
      'MTR_BULASIK',
      'MTR_FIRIN',
      'MTR_MOTOR',
      'MTR_KOMBI',
      'MTR_KLIMA',
      'MTR_FAN',
      'MTR_HIDROFOR',
    ],
    allowedChildPanels: [],
  },
  SP: {
    id: 'SP',
    code: 'SP',
    label: 'Sığınak Panosu',
    level: PANEL_LEVEL.GT_CHILD,
    defaultOutputs: [],
    allowedChildPanels: [],
    jenerator: false,
  },
  OP: {
    id: 'OP',
    code: 'OP',
    label: 'Otopark Pano',
    level: PANEL_LEVEL.GT_CHILD,
    defaultOutputs: [
      'PRZ_NORMAL',
      'AYD_NORMAL',
    ],
    allowedChildPanels: [],
  },
  KDP: {
    id: 'KDP',
    code: 'KDP',
    label: 'Kazan Dairesi Pano',
    level: PANEL_LEVEL.GT_CHILD,
    defaultOutputs: [],
    allowedChildPanels: [],
  },
};
